export function resolveOrgTokens(input?: string | null, orgName?: string | null) {
  if (!input) return '';
  const name = (orgName ?? '').trim();
  if (!name) return input;                    // no org, leave raw
  return input.replace(/####/g, name);        // replace every ####
}

export function withOrgName(s?: string, orgName?: string) {
  if (!s) return s;
  return s.replace(/####/g, orgName ?? 'the organization');
}